<template>
  <w-dialog :dialog-show="wxState" @handleClose="handleClose">
    <div slot="content" class="content flex-column-center">
      <p class="title">关注公众号，开启提醒</p>
      <p class="sub-title">微信上也可以随时查看、 投递简历</p>
      <img class="qr-code" :src="qrUrl"
           alt="">
      <p class="description">微信扫码 管理网申</p>
      <a v-show="!isWxMini && !isWechatBrowser" href="weixin://" class="dialog-footer flex-center">打开微信</a>
    </div>
  </w-dialog>
</template>

<script>
	import WDialog from './w-dialog'
	import { envMixin } from '../../assets/js/mixin/global'

	export default {
		name: 'w-wx-qr',
		mixins: [ envMixin ],
		props: {
			wxState: {
				type: Boolean,
				default: false
      },
      qrUrl: {
				type: String,
				default: ''
			}
		},
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {
			WDialog
		},
		methods: {
			handleClose () {
				this.$emit('handleClose')
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .content {
    width: 80vw;
    background-color: $color-light;
    border-radius: 6px;
    padding: 25px 0;
    .title {
      font-size: 20px;
      margin-bottom: 20px;
    }
    .sub-title {
      color: #9c9c9c;
      margin-bottom: 16px;
    }
    img {
      width: 200px;
    }
    .description {
      margin: 20px 0 16px;
      color: $color-dark-gray;
    }
    .dialog-footer {
      width: 210px;
      height: 40px;
      background-color: #3DB742;
      border-radius: 2px;
      color: $color-light;
    }
  }
</style>
